import ReportSummaryNG from '@/models/ReportSummaryNG/ReportSummaryNG';

export default class ReportSummaryNGFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.filterPeriodFrom = '';
		this.tempId = '';
		this.item = '';
		this.total = '';
		this.m1 = '';
		this.m2 = '';
		this.m3 = '';
		this.m4 = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			filterPeriodFrom : '0',
			tempId : '0',
			item : '0',
			total : '0',
			m1 : '0',
			m2 : '0',
			m3 : '0',
			m4 : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}